import { render, staticRenderFns } from "./commonTable.vue?vue&type=template&id=d1a0e946&scoped=true"
import script from "./commonTable.vue?vue&type=script&lang=js"
export * from "./commonTable.vue?vue&type=script&lang=js"
import style0 from "./commonTable.vue?vue&type=style&index=0&id=d1a0e946&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a0e946",
  null
  
)

export default component.exports